let controller;

export const useAbortController = () => 
{
    if(!controller)
    {
        controller = new AbortController();
    }
    return controller;
}